import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
export var formatUrl = function formatUrl(id, base, transformations) {
  // GEN-AI START Cursor-claude-3.7-sonnet
  // More robust handling of leading and trailing slashes
  var cleanBase = base.endsWith('/') ? base.slice(0, -1) : base;
  var cleanId = id.startsWith('/') ? id.slice(1) : id;
  var transformString = Object.entries(transformations !== null && transformations !== void 0 ? transformations : {}).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return "".concat(key, "=").concat(value);
  }).join(',');
  var version = transformString.length === 0 ? 'public' : transformString; // Join with slashes and ensure no double slashes

  var url = "".concat(cleanBase, "/").concat(cleanId, "/").concat(version); // Final normalization to catch any remaining double slashes

  return url.replace(/([^:]\/)\/+/g, '$1'); // GEN-AI END Cursor-claude-3.7-sonnet
};
export var transform = function transform(id, base) {
  return function (_ref3) {
    var width = _ref3.width,
        height = _ref3.height;
    var transformations = {};

    if (width) {
      transformations.width = width === null || width === void 0 ? void 0 : width.toString();
    }

    if (height) {
      transformations.height = height === null || height === void 0 ? void 0 : height.toString();
    }

    return new URL(formatUrl(id, base, transformations));
  };
};